import { api } from "./api";

export const GetHostelList = async (addURL = ``) => {
  let url = `/hostel/list?${addURL}`;
  return await api.get(url);
};

export const DeleteHostelData = async (id) => {
  return await api.get(`/hostel/delete?id=${id}`);
};

export const CreateHostel = async (data) => {
  return await api.post(`/hostel/add`, data);
};

export const UpdateHostel = async (data) => {
  return await api.post(`/hostel/update`, data);
};

export const StatusChange = async (id) => {
  return await api.get(`/hostel/status/change?id=${id}`);
};

// Hostel Rooms /  Beds Api's

export const HostelBedsList = async (addUrl = "") => {
  let url = `/hostel/bed/list?${addUrl}`;
  return await api.get(url);
};

export const HostelRoomAdd = async (data) => {
  return await api.post(`/hostel/room/add`, data);
};

export const HostelAddBed = async (data) => {
  return await api.post(`/hostel/bed/add`, data);
};

export const HostelBedDelete = async (id) => {
  return await api.get(`/hostel/bed/delete?id=${id}`);
};

export const HostelBedUpdate = async (data) => {
  return await api.post(`/hostel/bed/update`, data);
};

export const HostelBedStatusChange = async (data) => {
  return await api.post(`/hostel/bed/status/change`, data);
};

//Hostel Students Api's

export const HostelStudentList = async (addUrl = "") => {
  let url = `/hostel/student/list?${addUrl}`;
  return await api.get(url);
};

export const HostelStudentCreate = async (data) => {
  return await api.post(`/hostel/student/add`, data);
};

export const HostelStudentDelete = async (id) => {
  return await api.get(`/hostel/student/delete?id=${id}`);
};

export const HostelStudentStatusChange = async (id, end_date) => {
  return await api.get(
    `/hostel/student/status/change?id=${id}&end_date=${end_date}`,
  );
};

export const HostelStudentView = async (id) => {
  return await api.get(`/hostel/student/view?id=${id}`);
};

export const HostelStudentUpdate = async (data) => {
  return await api.post(`/hostel/student/update`, data);
};

export const hostelStudentTransfer = async (data) => {
  return await api.post(`/hostel/student/transfer`, data);
};

export const HostelFeesCollection = async (addUrl = "") => {
  let url = `/hostel/fee-collection?${addUrl}`;
  return await api.get(url);
};

export const HostelFeesCollectionNew = async (addUrl = "") => {
  let url = `/hostel/fee/deposit/info?${addUrl}`;
  return await api.get(url);
};
export const HostelFeesPay = async (data) => {
  return await api.post(`/hostel/fee/deposit`, data);
};
export const HostelReceipt = async (id) => {
  return await api.get(`/hostel/fees/receipt?id=${id}`);
};

export const HostelRoomList = async (addUrl = "") => {
  let url = `/hostel/room/list?${addUrl}`;
  return await api.get(url);
};
export const DashboardData = async (addUrl = "") => {
  let url = `/hostel/reports/dashboard?${addUrl}`;
  return await api.get(url);
};

export const GetCollectionReport = async (addUrl = "") => {
  let url = `/hostel/reports/collection?${addUrl}`;
  return await api.get(url);
};
export const GetExpenseReport = async (addUrl = "") => {
  let url = `/hostel/reports/expenses?${addUrl}`;
  return await api.get(url);
};
export const GetDueFeeReport = async (addUrl = "") => {
  let url = `/hostel/reports/due_fees?${addUrl}`;
  return await api.get(url);
};
export const GetReport = async (addUrl = "") => {
  let url = `/hostel/reports/overview?${addUrl}`;
  return await api.get(url);
};
export const GetCreditDebit = async (addUrl = "") => {
  let url = `/hostel/reports/credit-debit?${addUrl}`;
  return await api.get(url);
};

// student details

export const getDetails = async (id) => {
  let url = `/hostel/student/view?id=${id}`;
  return await api.get(url);
};

// hostel discount update

export const UpdateStudentDiscountHostel = async (data) => {
  return await api.post(`/hostel/student/month/fees`, data);
};

export const UpdateStudentDiscountHostel2 = async (data) => {
  return await api.post(`/hostel/student/hostel/fees`, data);
};

export const hostelMonthlyReport = async (addUrl = "") => {
  let url = `/hostel/reports/student/with${addUrl}`;
  return await api.get(url);
};
export const studentMonthTransactionDelete = async (data) => {
  return await api.post(`/hostel/student/month/transaction/delete`, data);
};

export const addStafftoHostel = async (data) => {
  return await api.post(`hostel/assign/to/staff`, data);
};

export const HostelFeeGeneratePreview = async (data) => {
  return await api.post(`/hostel/student-fee/preview`, data);
};

export const HostelFeeGenerate = async (data) => {
  return await api.post(`/hostel/student-fee/generate`, data);
};

export const HostelStudentFeeSummary = async (addUrl = "") => {
  let url = `/hostel/student-fee/summary?${addUrl}`;
  return await api.get(url);
};

export const HostelStudentFeeLedger = async (id) => {
  return await api.get(`/hostel/student-fee/ledger?id=${id}`);
};
